
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    handleClick: {
      type: Function,
      default: () => {}
    }
  }
}
